import { render, staticRenderFns } from "./InstantQuotation.vue?vue&type=template&id=39320364&lang=html&"
import script from "./InstantQuotation.vue?vue&type=script&lang=js&"
export * from "./InstantQuotation.vue?vue&type=script&lang=js&"
import style0 from "./InstantQuotation.vue?vue&type=style&index=0&id=39320364&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports